import { connect } from 'react-redux';
import WarrantyDialogue from './WarrantyDialogue';


const mapStateToProps = state => ({
    selectedFinancing: state.settings.selectedFinancing,
    taxEntity: state.tax.taxEntity,
    projectState: state.projectaddress.projectState,
    resiToggle: state.tax.resiToggle,
});

const combinedActions = {
};

export default connect(mapStateToProps, combinedActions)(WarrantyDialogue);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/WarrantyDialogue/index.js